/* eslint-disable @typescript-eslint/no-unused-vars */
import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, LinearProgress, MenuItem, Paper, Select, Snackbar, SnackbarCloseReason } from '@mui/material';
import { useState } from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import RelatorioNfe from './Rnfepdf';
import { NavBarRelatoriosFiscal } from '../../../shared/components/navbar/NavBarRelatoriosFiscal';
import { RelatorioFiscalService } from '../../../shared/services/api/Fiscal/ServiceRelatorioFinanceiro';

export const RelatoriosNfe: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [dataInicial, setDataInicial] = useState<Dayjs | null>(
    dayjs().startOf('month')
  );
  const [dataFinal, setDataFinal] = useState<Dayjs | null>(dayjs());
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tipo, setTipo] = useState('todas');
  const [status, setStatus] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };
  
  const handleSave = () => {
    let statusValue = status;
    
    if (tipo === 'todas') {
      statusValue = '0';
    } else if (tipo === 'canceladas') {
      statusValue = '3';
    }
    
    RelatorioFiscalService
      .RNfe(tipo, dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'), statusValue)
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          if (result.length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            RelatorioNfe(result as any, `Período: ${dayjs(dataInicial).format('DD/MM/YYYY')} a ${dayjs(dataFinal).format('DD/MM/YYYY')}`);
          } else {
            setTms('warning');
            setMsg('Nenhum registro encontrado');
            setOpenmsg(true);
          }
        }
      });
  };

  const handleTipoChange = (value: string) => {
    setTipo(value);
    if (value === 'todas' || value === 'canceladas') {
      setStatus('');
    }
  };
  
  const handleStatusChange = (value: string) => {
    setStatus(value);
  };
  
  // Determine if status select should be shown
  const showStatusSelect = tipo !== 'todas' && tipo !== 'canceladas';

  return (
    <Box alignItems="center" width='auto' alignContent='center' height="auto" display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box gap={1} padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' width='80%' height="20%" margin={1} alignContent='center'></Box>
      <Box
        component={Paper}
        sx={{
          width: '100%',
          maxWidth: 600,   // largura máxima
          margin: 'auto',
          padding: 1
        }}
      >

        <NavBarRelatoriosFiscal />
        <DialogTitle>Relatório NFE</DialogTitle>
        <DialogContent dividers>
          {isLoading && (
            <Grid item>
              <LinearProgress variant='indeterminate' />
            </Grid>
          )}
          <Grid container padding={1} item direction="row" gap={2}>
            <Grid container spacing={2} item direction="row" xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Tipo</InputLabel>
                  <Select
                    label="Tipo"
                    value={tipo}
                    size='small'
                    onChange={(e) => handleTipoChange(e.target.value)}
                  >
                    <MenuItem value="todas">Geral</MenuItem>
                    <MenuItem value="normal">Normal</MenuItem>
                    <MenuItem value="devolucao">Devolução</MenuItem>
                    <MenuItem value="canceladas">Canceladas</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Conditionally render Status select based on tipo */}
              {showStatusSelect && (
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Status</InputLabel>
                    <Select
                      label="Status"
                      value={status}
                      size='small'
                      onChange={(e) => handleStatusChange(e.target.value)}
                    >
                      <MenuItem value="1">Lançada</MenuItem>
                      <MenuItem value="2">Autorizada</MenuItem>
                      <MenuItem value="3">Cancelada</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}

              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format='DD/MM/YYYY'
                    value={dataInicial}
                    onChange={(newValue) => setDataInicial(newValue)}
                    label='Data Inicial'
                    slotProps={{
                      textField: {
                        size: 'small',
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format='DD/MM/YYYY'
                    value={dataFinal}
                    onChange={(newValue) => setDataFinal(newValue)}
                    label='Data Final'
                    slotProps={{
                      textField: {
                        size: 'small',
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button sx={{ minWidth: '30%' }} variant='outlined' autoFocus onClick={handleSave}>Visualizar</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};